import { Checkbox, FormControlLabel, styled } from '@mui/material';
import { List, ListItem } from '../../../components/List';
import { companyOpcoFundingType, fundingType } from '../../types';
import { CompanyDetails } from './CompanyDetails';

const DEFAULT_COMPANY_OPCO_FUNDING: Omit<fundingType, 'kind'> = {
    company: '',
    siret: '',
    address: '',
    managementName: '',
    managementEmail: '',
};

function Fundings(props: { funding: fundingType; setFunding: (funding: fundingType) => void }) {
    const { funding, setFunding } = props;
    return (
        <List>
            <ListItem>
                <CompanyContainer>
                    <FormControlLabel
                        control={<Checkbox checked={funding.kind === 'company'} />}
                        onChange={(_, checked) =>
                            setFunding(
                                checked
                                    ? ({
                                          kind: 'company',
                                          ...DEFAULT_COMPANY_OPCO_FUNDING,
                                      } as companyOpcoFundingType)
                                    : { kind: 'auto' },
                            )
                        }
                        label="Entreprise"
                        name={`company-funding`}
                    />
                    {funding.kind === 'company' && (
                        <CompanyDetails funding={funding} setFunding={setFunding} />
                    )}
                </CompanyContainer>
            </ListItem>
            <ListItem>
                <CompanyContainer>
                    <FormControlLabel
                        control={<Checkbox checked={funding.kind === 'opco'} />}
                        onChange={(_, checked) =>
                            setFunding(
                                checked
                                    ? ({
                                          kind: 'opco',
                                          ...DEFAULT_COMPANY_OPCO_FUNDING,
                                      } as companyOpcoFundingType)
                                    : { kind: 'auto' },
                            )
                        }
                        label="OPCO"
                        name={`opco-funding`}
                    />
                    {funding.kind === 'opco' && (
                        <CompanyDetails funding={funding} setFunding={setFunding} />
                    )}
                </CompanyContainer>
            </ListItem>
            <ListItem>
                <FormControlLabel
                    control={<Checkbox checked={funding.kind === 'vivea'} />}
                    onChange={(_, checked) => setFunding({ kind: checked ? 'vivea' : 'auto' })}
                    label="VIVEA"
                    name={`vivea-funding`}
                />
            </ListItem>
            <ListItem>
                <FormControlLabel
                    control={<Checkbox checked={funding.kind === 'france-travail'} />}
                    onChange={(_, checked) =>
                        setFunding({ kind: checked ? 'france-travail' : 'auto' })
                    }
                    label={
                        <span>
                            France Travail (
                            <UnderlinedText>
                                envoyer l'avis de situation à{' '}
                                <strong>formationcontinue@esaj.asso.fr</strong>
                            </UnderlinedText>
                            )
                        </span>
                    }
                    name={`france-travail-funding`}
                />
            </ListItem>
            <ListItem>
                <FormControlLabel
                    control={<Checkbox checked={funding.kind === 'auto'} />}
                    onChange={() => setFunding({ kind: 'auto' })}
                    label="Auto-financement"
                    name={`auto-funding`}
                />
            </ListItem>
        </List>
    );
}

const CompanyContainer = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
}));

const UnderlinedText = styled('span')(({ theme }) => ({ textDecoration: 'underline' }));

export { Fundings };
